// Languages of the backoffice. A language = one entry here + one folder locales/<code>/ with the same
// json files as locales/fr/ (French is the reference: a key missing elsewhere falls back to it).
export const LANGUAGES = [
  { code: "fr", label: "Français", short: "FR", intl: "fr-FR", dir: "ltr", dayjs: "fr", moment: "fr" },
  { code: "en", label: "English", short: "EN", intl: "en-GB", dir: "ltr", dayjs: "en", moment: "en" },
  { code: "ar", label: "العربية", short: "ع", intl: "ar-MA", dir: "rtl", dayjs: "ar-ma", moment: "ar-ma" },
];

export const DEFAULT_LANGUAGE = "fr";
